import { getUUID } from './get-uuid';

// Use a Symbol for a non-colliding shared window property
const MAGPIE_FRAME_ID_KEY = Symbol.for('@@magpie-lib/frame-id');

/**
 * Gets or creates a unique frame ID for the current window context.
 * This ID is shared across all instances of the library in the same frame.
 */
export const getOrCreateFrameId = () => {
  const win = window;
  if (!win[MAGPIE_FRAME_ID_KEY]) {
    win[MAGPIE_FRAME_ID_KEY] = getUUID();
  }
  return win[MAGPIE_FRAME_ID_KEY];
};

/**
 * Determines if a message originated from a different frame than the current one.
 *
 * @param message The message to check
 * @returns True if the message is from a different frame, false otherwise
 */
export const isMessageFromDifferentFrame = message => {
  const currentFrameId = getOrCreateFrameId();
  return Boolean(message.senderFrameId && message.senderFrameId !== currentFrameId);
};